import { useForm, UseFormReturn, UseFormProps } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

/**
 * This function is type inference ready and will auto-validate the useForm with the proper values.
 * @param schema - A valid you schema
 * @param useFormProps
 * @returns
 */
export function useFormWithSchema<T extends YupSchemaType>(
  schema: T,
  useFormProps?: UseFormProps<Yup.Asserts<T>>
): UseFormReturn<Yup.Asserts<T>> {
  return useForm({ ...useFormProps, resolver: yupResolver(schema) });
}
export type YupSchemaType = Yup.ObjectSchema<{
  [x: string]: SchemaValueType;
}>;
export type SchemaValueType = Yup.Maybe<string | undefined>;
export const validationMap = {
  email: Yup.string().required('Questo campo è obbligatorio').email('E-mail non valida'),
};
export const notRequired = Yup.string().notRequired();
export const commonTextValidation = Yup.string().required('Questo campo è obbligatorio');
